import React from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../AdminDashboard/Sidebar';
import TopBar from '../AdminDashboard/TopBar';
import HRSidebar from '../HR/HRSidebar';
import HRTopbar from '../HR/HRTopbar';
import EnrollmentSidebar from './EnrollmentSidebar';
import EnrollmentTopBar from './EnrollmentTopBar';

// Page chrome for screens shared by Enrollment Coordinator, Org Manager / Super Admin and Nurse Lead.
const RoleShell = ({ title, children }) => {
    const { user } = useSelector((state) => state.auth);
    const role = user?.role;
    let side = <Sidebar />;
    let top = <TopBar />;
    if (role === 'enrollment') {
        side = <EnrollmentSidebar />;
        top = <EnrollmentTopBar title={title} />;
    } else if (role === 'HrLead' || role === 'HrMedical') {
        side = <HRSidebar />;
        top = <HRTopbar />;
    }
    return (
        <>
            {side}
            <section className="home-section">
                {top}
                <div className="shadow-lg p-3 mb-2 mr-4 ml-4 rounded">
                    <div className="home-content">{children}</div>
                </div>
            </section>
        </>
    );
};

export default RoleShell;
